import { useEffect, useState } from "react";
import { createFileRoute, Link, Outlet, useRouter } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { buildHead } from "@/lib/seo";

const GREEN = "#1f1f1f";

export const Route = createFileRoute("/partner")({
  head: () => buildHead({ locale: "en", title: "Referral partner portal · Shugert", description: "Track Shugert referrals and commissions.", path: "/partner", altPath: "/partner", noindex: true }),
  component: PartnerLayout,
});

function PartnerLayout() {
  const router = useRouter();
  const [email, setEmail] = useState<string | null>(null);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => { setEmail(data.session?.user.email ?? null); setHydrated(true); });
    const { data: subscription } = supabase.auth.onAuthStateChange((_event, session) => setEmail(session?.user.email ?? null));
    return () => subscription.subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (hydrated && !email) router.navigate({ to: "/partner-login", search: { redirect: "/partner" } });
  }, [email, hydrated, router]);

  async function signOut() {
    await supabase.auth.signOut();
    router.navigate({ to: "/partner-login" });
  }

  if (!hydrated || !email) return <div className="flex min-h-dvh items-center justify-center bg-background"><p className="text-sm text-muted-foreground">Loading…</p></div>;

  return (
    <div className="min-h-dvh bg-background text-foreground">
      <header className="border-b border-border bg-card/30">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-6 py-4">
          <Link to="/partner" className="font-display text-lg font-semibold">Shugert <span style={{ color: GREEN }}>Referral Partners</span></Link>
          <nav className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.15em]"><Link to="/partner" activeOptions={{ exact: true }} className="rounded-full px-3 py-2 text-muted-foreground" activeProps={{ className: "rounded-full border border-border bg-background px-3 py-2 text-foreground" }}>Dashboard</Link><Link to="/partners/referral-terms" className="rounded-full px-3 py-2 text-muted-foreground hover:text-foreground">Terms</Link></nav>
          <div className="flex items-center gap-3"><span className="hidden text-xs text-muted-foreground sm:block">{email}</span><button onClick={signOut} className="rounded-full border border-border px-4 py-2 text-xs font-semibold hover:bg-card">Sign out</button></div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-10"><Outlet /></main>
    </div>
  );
}
